import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !*** CONFIGURATION API CONFIG                                         ***!
  \*******************************************************************************/

export const apiConfig = {
  // MANAGE PAYMENT TYPE
  Paymenttypes: BOM.baseUrl("paymenttypes"),
  Users: BOM.baseUrl("users"),

  Audits: BOM.baseUrl("audits"),

  //MANAGE EMPLOYEES
  Staff: BOM.baseUrl("staff"),
  Offices: BOM.baseUrl("offices"),

  // MANAGE ROLES
  Roles: BOM.baseUrl("roles"),

  // PASSWORD PREFERENCES
  PasswordPreferences: BOM.baseUrl("passwordpreferences"),

  // TWO FACTOR CONFIG
  TwoFactor: BOM.baseUrl("twofactor"),

  // AUTHORIZATION
  Permissions: BOM.baseUrl("permissions"),

  // CURRENCY
  Currencies: BOM.baseUrl("currencies"),
  GLAccounts: BOM.baseUrl("glaccounts"),

  // SCHEDULER JOBS
  Jobs: BOM.baseUrl("jobs"),
  Scheduler: BOM.baseUrl("scheduler"),

  //   CODES
  Codes: BOM.baseUrl("codes"),
  // Global Configuration
  Configurations: BOM.baseUrl("configurations"),

  // HOLIDAYS
  Holidays: BOM.baseUrl("holidays"),
  Offices: BOM.baseUrl("offices"),

  // WORKING DAYS
  Workingdays: BOM.baseUrl("workingdays"),
};

//
/*!*******************************************************************************!
  !*** CONFIGURATION LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const labelConfig = {
  //  PAYMENT TYPE
  managePaymentType: "Manage Payment Type",
  isCashPayment: "Is Cash Payment?",
  position: "Postion",
  newPaymentType: "New Payment Type",
  editPaymentType: "Edit Payment Type",
  paymentType: "Payment Type",
  name: "Name",
  description: "Description",
  newPaymentTypeMsg: "New Payment Type was successfully created",
  editPaymentTypeMsg: "Payment Type was successfully edited",
  deletePaymentTypeMsg: "Payment Type Deleted Successfully",
  office: "Office",
  branch: "Branch",
  active: "Active",
  status: "Status",
  action: "Action",
  entity: "Entity ",
  customer: "Customer",
  toDate: "To Date",
  clientNumber: "Client Number",
  activationDate: "Activation Date",
  manageCurrency: "Manage Currency",
  currencyName: "Currency Name",
  currencyCode: "Currency Code",
  glAccountCode: "GL Account Code",
  glAccountName: "GL Account Name",
  newCurrency: "Create Currency",
  glAccount: "GL Account",
  newCurrencyMsg: "New Currency Created Successfully",
  updateCurrency: "Currencies Updated Successfully",
  schedulerJobs: "Scheduler Jobs",
  nextRun: "Next Run",
  prevRun: "Previous Run",
  prevRunStatus: "Previous Run Status",
  currentRunning: "Current Running",
  errorLog: "Error Log",
  detailSchedulerJobs: "Detail Scheduler Jobs",

  //   CODES
  code: "Code",
  manageCodes: "Manage Codes",
  codeName: "Code Name",
  systemDefined: "System Defined",
  newCode: "New Code",
  editCode: "Edit Code",
  newCodeValues: "New Code Values",
  addCodeValue: "Add Code Value",
  detailCode: "Code Details",
  newCodeMsg: "Code was successfully created",
  editCodeMsg: "Code was successfully edited",
  deleteCodeMsg: "Code Value Deleted Successfully",
  newCodeValueMsg: "Code Value was successfully created",
  editCodeValueMsg: "Code Value was successfully edited",
  //   deleteCodeValueMsg: "Code Value Deleted Successfully",

  // GLobal Configurations
  //   CODES
  configuration: "Configuration",
  configurations: "Configurations",
  manageConfigurations: "Manage Configurations",
  editConfiguration: "Edit Configruation",
  enabled: "Enabled?",
  value: "Value",
  stringValue: "String Value",
  editConfigurationMsg: "Configuration was successfully edited",
  stringValue: "String Value",
  jobName: "Job Name",
  cronExpression: "Cron Expression",
  isActiveJob: "Is Active Job?",
  follow: "Follow",
  isoCode: "ISO Code",
  numericCode: "Numeric Code",
  editSchedulerJobs: "Edit Scheduler Jobs",
  refresh: "Refresh",
  suspend: "Suspend",
  activate: "Activate",
  editSchedulerJobsMsg: "Scheduler Jobs Edited Successfully",
  holidays: "Holidays",
  manageHolidays: "Manage Holidays",
  newHoliday: "New Holiday",
  repaymentSchedulingType: "Repayment Scheduling Type",
  fromDate: "From Date",
  repaymentScheduledTo: "Repayment Scheduled To",
  applicableOffices: "Applicable Offices",
  selectedOffices: "Selected Offices",
  newHolidayMsg: "Holiday Successfully Created",
  detailHoliday: "Detail Holiday",
  activateHoldayMsg: "Holiday Activated Successfully",
  deleteHoldayMsg: "Holiday Deleted Successfully",
  editHoliday: "Edit Holiday",
  workingDays: "Working Days",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  paymentsDueOnNonWorkingDays: "Payments due on non working days",
  extendTermForLoans: "Extend the term for loans following a daily repayment schedule",
  updateHolidayMsg: "Holiday Successfully Updated",
  schedulerJobHistory: "Scheduler Job History",
  version: "Version",
  runStartTime: "Run Start Time",
  runType: "Run Type",
  updateWorkingDaysMsg: "Working Days was successfully updated",
};

/*!*******************************************************************************!
    !*** CONFIGURATION STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  // MANAGE PAYMENT TYPE ITEMS
  managePaymentTypeItems: [{ title: labelConfig.managePaymentType }],
  newPaymentTypeBreadcrumbItems: [
    {
      title: <Link to="/manage-payment-type">{labelConfig.managePaymentType}</Link>,
    },
    { title: labelConfig.newPaymentType },
  ],

  editPaymentTypeBreadcrumbItems: [
    {
      title: <Link to="/manage-payment-type">{labelConfig.managePaymentType}</Link>,
    },
    { title: labelConfig.editPaymentType },
  ],

  // MANAGE CODES  ITEMS
  manageCodeItems: [{ title: labelConfig.manageCodes }],
  newCodeBreadcrumbItems: [
    {
      title: <Link to="/manage-codes">{labelConfig.manageCodes}</Link>,
    },
    { title: labelConfig.newCode },
  ],

  detailCodeBreadcrumbItems: [
    {
      title: <Link to="/manage-codes">{labelConfig.manageCodes}</Link>,
    },
    { title: labelConfig.detailCode },
  ],
  editCodeBreadcrumbItems: [
    {
      title: <Link to="/manage-codes">{labelConfig.manageCodes}</Link>,
    },
    { title: labelConfig.editCode },
  ],

  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],
  yesOrNoData: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  filterByEntries: [
    { label: "All", value: "All" },
    { label: "Manual Entries", value: "Manual Entries" },
    { label: "System Entries", value: "System Entries" },
  ],
  yesOrNo: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],

  trueOrFalseData: [
    { label: "True", value: true },
    { label: "False", value: false },
  ],

  manageCurrencyBreadcrumbItems: [{ title: labelConfig.manageCurrency }],

  newCurrencyBreadcrumbItems: [
    { title: <Link to="/manage-currency">{labelConfig.manageCurrency}</Link> },
    { title: labelConfig.newCurrency },
  ],

  schedulerJobsBreadcrumbItems: [{ title: labelConfig.schedulerJobs }],

  detailSchedulerJobsBreadcrumbItems: [
    {
      title: <Link to="/manage-scheduler-jobs">{labelConfig.schedulerJobs}</Link>,
    },
    { title: labelConfig.detailSchedulerJobs },
  ],
  schedulerJobsBreadcrumbItems: [{ title: labelConfig.schedulerJobs }],

  editSchedulerJobsBreadcrumbItems: [
    {
      title: <Link to="/manage-scheduler-jobs">{labelConfig.schedulerJobs}</Link>,
    },
    { title: labelConfig.editSchedulerJobs },
  ],

  schedulerJobHistoryBreadcrumbItems: [
    {
      title: <Link to="/manage-scheduler-jobs">{labelConfig.schedulerJobs}</Link>,
    },
    { title: labelConfig.schedulerJobHistory },
  ],

  // MANAGE CONFIGURATION ITEMS

  manageConfigurationsItems: [{ title: labelConfig.manageConfigurations }],

  editConfigurationBreadcrumbItems: [
    {
      title: <Link to="/manage-config">{labelConfig.manageConfigurations}</Link>,
    },
    { title: labelConfig.editConfiguration },
  ],

  manageHolidaysBreadcrumbItems: [{ title: labelConfig.manageHolidays }],

  newHolidayBreadcrumbItems: [
    { title: <Link to="/manage-holidays">{labelConfig.manageHolidays}</Link> },
    { title: labelConfig.newHoliday },
  ],

  detailHolidayBreadcrumbItems: [
    { title: <Link to="/manage-holidays">{labelConfig.manageHolidays}</Link> },
    { title: labelConfig.detailHoliday },
  ],

  editHolidayBreadcrumbItems: [
    { title: <Link to="/manage-holidays">{labelConfig.manageHolidays}</Link> },
    { title: labelConfig.editHoliday },
  ],

  manageworkingDaysItems: [{ title: labelConfig.workingDays }],
};
